import { useOrderListAlertAPI } from "@/app/hooks/api_hooks/orders/useOrderListAlertAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { IOrderManagementState } from "@/app_redux/reducers/slices/auth/order_management_slice";
import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import config from "@/configs/development";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { doc, onSnapshot } from "firebase/firestore";
import { IOrderManagementFilterBody } from "@/api_framework/api_modals/Orders";
// Initialize firebase only once
if (!firebase.apps.length) {
  firebase.initializeApp(config.firebase);
}

const firestore = firebase.firestore();

const ToastNotificationComponent = () => {
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState } = useRouteInfo(routeId);

  const { isUserPopupModalActive } = routeState.state as IOrderManagementState;

  const { execute: fetchOrderListAPI } = useOrderListAlertAPI();
  const mappedClinicId = useAppSelector((state) => state.root.UIStates.mappedClinicId);
  const navigate = useNavigate(); // Hook for navigation
  // Function to trigger a toast notification
  const handelView = () => {
    navigate(`/app/qc-orders?status=2`);
  };

  const notify = (ordernumber, isPack) => {
    toast(
      <div className="flex items-center gap-3">
        <span className="text-[#FFFFFF] font-semibold">{`${ordernumber} ${
          isPack === "pack" ? "Order need to be pack" : "new order received"
        }`}</span>
      </div>,
      {
        position: "top-right",
        autoClose: 6000, // Close after 3 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        pauseOnFocusLoss: false, // Pause when tab is inactive
        theme: "dark",
        transition: Bounce,
        style: {
          backgroundColor: "#193A6A",
          color: "#FFFFFF",
          fontWeight: 600,
          fontSize: "16px",
          padding: "10px",
        },
        icon: <ShoppingCartIcon style={{ fill: "#F8BF58" }} className="w-8 h-8" />,
      },
    );
  };

  const notifyForVideo = (alert_text: string) => {
    toast(
      <div className="flex items-center gap-3">
        <span className="text-[#FFFFFF] font-semibold">{alert_text}</span>
      </div>,
      {
        position: "top-right",
        autoClose: 6000, // Close after 3 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        pauseOnFocusLoss: false, // Pause when tab is inactive
        theme: "dark",
        transition: Bounce,
        style: {
          backgroundColor: "#193A6A",
          color: "#FFFFFF",
          fontWeight: 600,
          fontSize: "16px",
          padding: "10px",
        },
        // icon: <ShoppingCartIcon style={{ fill: "#F8BF58" }} className="w-8 h-8" />,
      },
    );
  };

  // Listen to firebase changes
  useEffect(() => {
    try {
      const statusRef = doc(firestore as any, "videoconsultation_cm_reminders_vms", mappedClinicId);

      const unsubscribe = onSnapshot(statusRef, (snapshot) => {
        if (snapshot.exists()) {
          const callstatus = snapshot.data();

          if (callstatus?.booking_id) {
            notifyForVideo(callstatus?.alert_text);
            //
          } else {
            //
          }
        } else {
          //
        }
      });

      return () => unsubscribe();
    } catch (error) {
      console.error("Error listening to Firestore:", error);
    }
  }, []);

  useEffect(() => {
    const fetchOrders = () => {
      const today = new Date().toISOString().split("T")[0];
      const requestBody: IOrderManagementFilterBody = {
        clinic_id: mappedClinicId?.split(","),
        start_date: today,
        end_date: today,
        order_status: "",
        source: "CLINIC",
      };
      fetchOrderListAPI(requestBody).then(({ status, message }) => {
        if (status) {
          const lastOrderItem = parseInt(localStorage.getItem("order_item") || "0", 10);
          const confirmedOrders = message?.filter((order) => order?.order_details?.order_status === "confirmed");
          if (confirmedOrders?.length > 0) {
            notify(confirmedOrders?.length, "pack");
          }
          if (lastOrderItem < message?.length) {
            notify(message?.length - lastOrderItem, "ll"); // Notify about new orders
            localStorage.setItem("order_item", message?.length);
          }
        }
      });
    };

    // Fetch immediately
    if (!isUserPopupModalActive) {
      fetchOrders();
    }

    // Set interval to fetch every 3 minutes
    const intervalId = setInterval(fetchOrders, 8 * 60 * 1000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [mappedClinicId, isUserPopupModalActive]);

  return (
    <div>
      <div onClick={() => handelView()}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          transition={Bounce}
        />
      </div>
    </div>
  );
};

export default ToastNotificationComponent;
